export type EducationalResourceType =
  | "VIDEO"
  | "AUDIO"
  | "PDF"
  | "WEB"
  | "IMAGE";

export const EDUCATIONAL_RESOURCE_TYPES: EducationalResourceType[] = [
  "VIDEO",
  "AUDIO",
  "PDF",
  "WEB",
  "IMAGE",
];

export interface EducationalResourceLanguage {
  _id?: string;
  language: string;
  title: string;
  description: string;
  url: string;
}

export interface EducationalResourceAttributes {
  thumbnailUrl?: string;
  duration?: number;
}

export interface EducationalResource {
  _id: string;
  id: string;
  accountId: string;
  categoryId: string;
  type: EducationalResourceType;
  status: "ACTIVE" | "INACTIVE";
  languages: EducationalResourceLanguage[];
  attributes?: EducationalResourceAttributes;
  isDeleted: boolean;
  createdAt: string;
  updatedAt?: string;
  createdBy: string;
  updatedBy?: string;
}

export type EducationalResourcePayload = {
  categoryId: string;
  type: EducationalResourceType;
  status: "ACTIVE" | "INACTIVE";
  languages: EducationalResourceLanguage[];
  attributes?: EducationalResourceAttributes;
  createdBy?: string;
  updatedBy?: string;
};
